/*
 * VDC Shipment Protection - RETIRED 2026-06-10 (v3, inert). Redo's own checkout-plus
 * component handles protection. This file is still loaded by sections/cart-drawer.liquid.
 *
 * VDC 2026-10-21: cart drawer refresh fix.
 * The mobile sticky ATC (snippets/vdc-sticky-atc.liquid) adds to cart itself and only
 * requests the 'variant-added' section, then fires cart:change with no cart-drawer HTML.
 * Impact's drawer then opens with the stale page-load contents ("Your cart is empty")
 * even though the item is in the cart. This listener asks Impact to re-fetch the drawer
 * (cart:refresh) whenever a cart:change arrives without the drawer's section.
 * Throttled to once per 1.5s so it can never loop.
 */
(function () {
  'use strict';
  if (window.__vdcDrawerRefreshFix) return;
  window.__vdcDrawerRefreshFix = { fired: 0 };
  var last = 0;
  function drawerSectionId() {
    var d = document.querySelector('cart-drawer');
    var s = d && d.closest('.shopify-section');
    return s && s.id ? s.id.replace(/^shopify-section-/, '') : '';
  }
  document.addEventListener('cart:change', function (e) {
    try {
      var id = drawerSectionId();
      if (!id) return;
      var cart = e && e.detail && e.detail.cart;
      if (cart && cart.sections && cart.sections[id]) return;
      var now = Date.now();
      if (now - last < 1500) return;
      last = now;
      setTimeout(function () {
        window.__vdcDrawerRefreshFix.fired++;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }, 50);
    } catch (err) {}
  });
})();
